import { render, staticRenderFns } from "./associatedDoc.vue?vue&type=template&id=78bcf661&scoped=true&"
import script from "./associatedDoc.vue?vue&type=script&lang=js&"
export * from "./associatedDoc.vue?vue&type=script&lang=js&"
import style0 from "./associatedDoc.vue?vue&type=style&index=0&id=78bcf661&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bcf661",
  null
  
)

export default component.exports